const FakeData = [
    {
        img: "https://images.medicinenet.com/images/image_collection/webmd_anatomy/abdomen-anatomy.jpg",
        name: "Whole Abdomen",
        description: "The abdomen contains all the digestive organs, including the stomach, small and large intestines, pancreas, liver, and gallbladder",
    },
    {
        img: "https://err.ersjournals.com/content/errev/29/156/190136/F1.large.jpg",
        name: "PP",
        description: "This test is done to see how your body responds to sugar and starch after you eat a meal.As you digest the food in your stomach, blood glucose, or blood sugar levels rise.",
    },
    {
        img: "https://ih-lss.wp02.ihealthspot.com/wp-content/uploads/sites/540/2020/01/content-img_pulmonary-medicine-diagnostics.jpg",
        name: "PFT",
        description: "Pulmonary function test (PFT) is noninvasive test that show how well the lungs are working. The test measures lung volume, capacity, rates of flow, and gas exchange.",
    },
    {
        img: "https://static.vecteezy.com/system/resources/previews/000/945/745/non_2x/hepatitis-b-surface-antibody-anti-hbs-testing-photo.jpg",
        name: "HBS & KUB",
        description: "USG KUB test is an ultrasonography (USG) or ultrasound of the lower abdomen which assesses the condition of your kidneys, ureters, and urinary bladder (KUB).",
    },
    {
        img: "https://images.medicinenet.com/images/featured/detail_thyroid2.jpg",
        name: "Thyroid",
        description: "Thyroid panel test can help identify various conditions including hypothyroidism, hyperthyroidism, and other thyroid diseases.",
    },
    {
        img: "https://qph.fs.quoracdn.net/main-qimg-607c5519829a32ac60cdb60feb4fb178",
        name: "Lower Abdomen",
        description: "Lower abdominal pain can be acute or chronic. It can be a symptom of minor or major digestive system conditions such as gas, indigestion and constipation.",
    }
]

export default FakeData;